export interface SurveyOption {
  id: string
  text: string
  questionId: string
  order: number
  createdAt: string
  updatedAt: string
}

export enum SurveyType {
  SEND_JD = 'sendJD',
  CREATE_JD = 'createJD',
}
export enum SurveyQuestionType {
  FREE_TEXT = 'freeText',
  SEARCH = 'search',
}
export interface SurveyQuestion {
  id: string
  text: string
  type: SurveyQuestionType
  required: boolean
  order: number
  surveyId: string
  createdAt: string
  updatedAt: string
  options: SurveyOption[]
}

export interface Survey {
  id: string
  title: string
  type: SurveyType
  description: string
  isActive: boolean
  createdById: string | null
  expiresAt: string | null
  maxResponses: number
  createdAt: string
  updatedAt: string
  questions: SurveyQuestion[]
}
